import React, { useCallback, useEffect } from 'react';
import { generatePath, useHistory, useLocation } from 'react-router';
import { EnumUserRoute } from '@components-member/userRoutes/enums';
import { QUERY_PARAMS } from 'global.enums';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import { AccountCreateDataProvider } from './AccountCreateDataProvider';

const useNavigateToContestDetailsOnAccountCreate = (hasAccountCreationQuery: boolean) => {
  const { tradingAccountsStore } = useMobxStore();
  const history = useHistory();

  const navigateToContestPage = useCallback(() => {
    const traidingContestId = new URLSearchParams(history.location.search).get(QUERY_PARAMS.CONTEST_ID);

    if (!traidingContestId) {
      return;
    }
    history.push(generatePath(EnumUserRoute.tradingContestDetails, { traidingContestId }));
  }, [history]);

  useEffect(() => {
    if (hasAccountCreationQuery) {
      tradingAccountsStore.subscribeOnSelfAccountCreate(navigateToContestPage);
    }

    return () => {
      tradingAccountsStore.unsubscribeOnSelfAccountCreate(navigateToContestPage);
    };
  }, [hasAccountCreationQuery, navigateToContestPage, tradingAccountsStore]);
};

export const AccountCreateEntry = observer(() => {
  const location = useLocation();
  const { tradingAccountsStore } = useMobxStore();

  const openModalOnLoad = useCallback(() => {
    tradingAccountsStore.openCreateTradingAccountModal();
  }, [tradingAccountsStore]);

  const closeModalHandler = () => {
    tradingAccountsStore.closeCreateTradingAccountModal();
  };

  const hasAccountCreationQuery = Boolean(new URLSearchParams(location.search).get(QUERY_PARAMS.OPEN_ACCOUNT));

  useEffect(() => {
    if (hasAccountCreationQuery) {
      openModalOnLoad();
    }
  }, [openModalOnLoad, hasAccountCreationQuery]);

  useNavigateToContestDetailsOnAccountCreate(hasAccountCreationQuery);

  return tradingAccountsStore.isCreateTradingAccountModalOpened ? (
    <AccountCreateDataProvider closeModalHandler={closeModalHandler} />
  ) : null;
});
